import * as luxon from 'luxon';

/* eslint-disable max-len */
import { createFeature, createReducer, on } from '@ngrx/store';

import { OrdSearchActions } from './ord-search.actions';
import { OrdSearchI } from 'src/app/api/ord-search/ord-search.result.int';

export interface State {
    error: string;
    loaded: boolean;
    loading: boolean;
    data: OrdSearchI;
    receivedTime: string;
}

export const initialState: State = {
    error: null,
    loaded: false,
    loading: false,
    data: null,
    receivedTime: null,
};

export default createFeature({
    name: 'ordSearch',
    reducer: createReducer(
        initialState,
        on(OrdSearchActions.error, (state: State, { error: messageText }): State => ({
            ...state,
            error: messageText,
            loaded: false,
            loading: false
        })),
        on(OrdSearchActions.reset, (state: State): State => ({
            ...state,
            data: null,
            error: null,
            loaded: false,
            loading: false
        })),
        on(OrdSearchActions.received, (state: State, { result }): State => ({
            ...state,
            data: result,
            error: null,
            loaded: true,
            loading: false,
            receivedTime: luxon.DateTime.now().toISO(),
        })),
        on(OrdSearchActions.load, (state: State, { }): State => ({
            ...state,
            loaded: false,
            loading: true
        }))
    )
}
);